import React from 'react';
import { Progress, Skeleton } from 'antd';

import { Label } from 'components/Statistic/Label';
import { Widget } from 'components/Statistic/Widget';
import cn from './styles.module.scss';

const progressItems = [
  { title: 'Employee Priced', percent: 87, strokeColor: '#55C2EF'},
  { title: 'Families Priced', percent: 51, strokeColor: '#51D9C2'},
  { title: 'Paymarket Priced', percent: 33, strokeColor: '#449BBF'},
];

export function ProgressWidget({ label, items = progressItems, loading }) {
  return (
    <Widget className={cn.progress}>
      <Label>
        {label}
      </Label>
      <Skeleton loading={loading} paragraph={{ rows: 2, width: '100%' }} active />
      {items.map((item, index) => (
        <div key={index}>
          <div className={cn.title}>{item.title}</div>
          <Progress size={[, 16]} percent={item.percent} strokeColor={item.strokeColor} trailColor="#DDF3FC" />
        </div>
      ))}
    </Widget>
  );
}
